// extracted by mini-css-extract-plugin
module.exports = {"root":"EventWrapper_root__13yc-","noInteraction":"EventWrapper_noInteraction__1FgY2","pointerPassthrough":"EventWrapper_pointerPassthrough__2xX6n"};